import type { ReactNode } from 'react';

export type BrandIconSize = 'sm' | 'md' | 'lg';

export type BrandIconColor = 'dark' | 'light';

export type BrandIconDef = {
  viewBox: string;
  fill: string;
  paths: () => ReactNode;
};

export const brandIcons = {
  '2-week-relief': {
    viewBox: '0 0 34 36',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M5.41807 6.42867C11.801 0.045705 22.1734 0.045705 28.5563 6.42867C33.9573 11.8296 34.7961 20.0334 31.0932 26.3141'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M28.577 29.5663C22.194 35.9493 11.8217 35.9493 5.43875 29.5663C0.0377743 24.1654 -0.801024 15.9616 2.90192 9.68094'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.41807 6.42869L5.41807 0.639006'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M28.5775 29.57V35.3597'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.9971 7.75993V18.255L22.7867 24.0447'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  bloating: {
    viewBox: '0 0 34 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M4.79481 1.56695e-05C5.1472 0.0027569 5.43086 0.290669 5.42884 0.643042C5.41458 2.69876 5.38568 4.32141 5.40588 5.65645C5.4261 6.99153 5.49648 7.99189 5.66848 8.79969C5.83753 9.59334 6.10345 10.1928 6.5172 10.7298C6.93828 11.2762 7.53605 11.7894 8.41632 12.3763C11.5804 14.4857 13.2635 17.4509 12.607 20.0516C11.9362 22.7075 8.98263 24.4539 4.05193 24.454C3.25865 24.454 2.75586 24.6697 2.40742 25.0011C2.04285 25.3484 1.77263 25.8936 1.59066 26.6846C1.21978 28.2972 1.28311 30.5789 1.28312 33.3575C1.28313 33.7101 0.996644 33.9961 0.644092 33.9965C0.291164 33.9965 0.00506112 33.7104 0.00505997 33.3575C0.00504447 30.6834 -0.0683643 28.1934 0.344546 26.398C0.554497 25.4854 0.906503 24.6664 1.52576 24.0765C2.16136 23.4714 3.00556 23.1759 4.05193 23.1759C8.7995 23.1758 10.9195 21.5136 11.3678 19.7391C11.8297 17.9095 10.6773 15.4207 7.70739 13.4407C6.7722 12.8172 6.04637 12.2134 5.50473 11.5106C4.95578 10.7982 4.62041 10.0148 4.41838 9.06628C4.2194 8.13203 4.14832 7.02984 4.12782 5.67642C4.10732 4.32268 4.13667 2.66841 4.15078 0.635054C4.15342 0.282301 4.44201 -0.00243249 4.79481 1.56695e-05ZM9.77925 1.56695e-05C10.132 7.96668e-05 10.4181 0.286324 10.4183 0.639048C10.4183 2.01033 10.4089 3.2737 10.4442 4.38937C10.4797 5.50912 10.56 6.43653 10.7258 7.1382C10.8969 7.86134 11.1269 8.20484 11.3449 8.34338C11.5254 8.4579 11.8695 8.53385 12.583 8.23055C13.6104 7.79377 15.6467 6.76359 17.9409 6.83366C20.3219 6.90665 22.8668 8.14504 24.9782 11.915C26.622 14.8506 26.6311 19.0111 24.6407 22.432C22.6281 25.8911 18.6094 28.5436 12.3044 28.5438C11.532 28.5438 10.8405 28.5259 10.2276 28.5088C9.61081 28.4917 9.08182 28.4749 8.61702 28.4749C7.66005 28.4749 7.11317 28.5516 6.76382 28.7395C6.4769 28.894 6.2369 29.1746 6.07187 29.8887C5.90113 30.6279 5.83724 31.7206 5.83723 33.3575C5.83723 33.7104 5.55112 33.9965 5.19819 33.9965C4.8454 33.9964 4.55916 33.7103 4.55916 33.3575C4.55917 31.7231 4.61965 30.4978 4.82676 29.6012C5.03965 28.6798 5.43194 28.005 6.15774 27.6142C6.8212 27.2571 7.66978 27.1968 8.61702 27.1968C9.10438 27.1968 9.6561 27.2149 10.2625 27.2318C10.8731 27.2488 11.5503 27.2657 12.3044 27.2657C18.2145 27.2656 21.7804 24.8053 23.5354 21.789C25.3125 18.7347 25.2727 15.0564 23.8629 12.539C21.9339 9.09482 19.7641 8.16881 17.902 8.11173C15.9535 8.05218 14.2166 8.92493 13.0833 9.40677C12.1935 9.78499 11.3535 9.86103 10.6609 9.42174C10.0062 9.00621 9.67314 8.24137 9.48171 7.43176C9.28511 6.59997 9.20224 5.56683 9.16618 4.42931C9.13001 3.28731 9.14022 1.9939 9.14022 0.639048C9.14042 0.286381 9.42658 0.000173571 9.77925 1.56695e-05Z'
          fill='currentColor'
        />
        <path
          d='M33.361 9.54255C33.7139 9.54255 34 9.82865 34 10.1816C33.9998 10.5344 33.7138 10.8206 33.361 10.8206L28.4534 10.8206C28.1006 10.8205 27.8145 10.5343 27.8144 10.1816C27.8144 9.82869 28.1005 9.54262 28.4534 9.54255L33.361 9.54255ZM31.6975 2.48923C31.947 2.23967 32.3516 2.23967 32.6011 2.48923C32.8506 2.73879 32.8507 3.14331 32.6011 3.39286L28.3605 7.63344C28.111 7.883 27.7055 7.883 27.4559 7.63344C27.2068 7.38385 27.2065 6.97921 27.4559 6.72981L31.6975 2.48923ZM25.1814 0C25.5343 -3.74631e-08 25.8204 0.286104 25.8204 0.639032V5.5466C25.8201 5.89931 25.5341 6.18563 25.1814 6.18563C24.8287 6.18545 24.5426 5.8992 24.5423 5.5466V0.639032C24.5423 0.286215 24.8286 0.00017977 25.1814 0Z'
          fill='currentColor'
        />
      </>
    ),
  },
  gas: {
    viewBox: '0 0 32 34',
    fill: 'none',
    paths: () => (
      <>
        <circle
          cx='15.9999'
          cy='8.09167'
          r='7.46667'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <circle
          cx='15.9999'
          cy='21.9579'
          r='3.73333'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <circle
          cx='16'
          cy='30.4908'
          r='2.13333'
          stroke='currentColor'
          strokeWidth='1.25'
        />
      </>
    ),
  },
  regularity: {
    viewBox: '0 0 34 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M26.8165 21.3629C30.7813 20.3921 33.3608 18.7724 33.3608 17C33.3608 9.79573 0.639098 13.7278 0.639098 6.09272C0.639098 2.82055 7.97967 0.639098 17 0.639098C26.0203 0.639098 33.3608 2.82055 33.3608 6.09272C33.3608 8.27417 30.7731 9.47124 26.8165 10.4556'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.18345 12.6362C3.21866 13.6069 0.639098 15.2266 0.639098 16.9991C0.639098 24.2033 33.3608 20.2712 33.3608 27.9063C33.3608 31.1785 26.0203 33.3599 17 33.3599C7.97967 33.3599 0.639098 31.1785 0.639098 27.9063C0.639098 25.7249 3.22684 24.5278 7.18345 23.5434'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  'digestive-health': {
    viewBox: '0 0 34 34',
    fill: 'none',
    paths: () => (
      <path
        d='M9.36382 33.3594C9.36382 28.9967 18.0892 33.3594 21.3613 33.3594C26.253 33.3594 26.253 26.8154 21.3613 26.8154C17.8711 26.8154 8.41765 28.9967 6.09178 28.9967C0.616574 28.9967 0.616574 21.362 6.09178 21.362C11.567 21.362 22.9973 24.634 27.3627 24.634C35.3602 24.634 35.3602 14.8179 27.3627 14.8179C21.3613 14.8179 12.6359 19.1806 6.63712 19.1806C-1.36028 19.1806 -1.36028 9.3645 6.63712 9.3645C10.9998 9.3645 22.4547 12.6365 27.9081 12.6365C33.3615 12.6365 33.3833 5.00178 27.9081 5.00178C25.5822 5.00178 16.1288 7.18314 12.6386 7.18314C7.74689 7.18314 7.74689 0.63907 12.6386 0.63907C15.9106 0.63907 24.6361 5.00178 24.6361 0.63907'
        stroke='currentColor'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ),
  },
  'regularity-clock': {
    viewBox: '0 0 34 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M17 33.3609C26.0359 33.3609 33.3609 26.0359 33.3609 17C33.3609 7.96412 26.0359 0.639098 17 0.639098C7.96412 0.639098 0.639098 7.96412 0.639098 17C0.639098 26.0359 7.96412 33.3609 17 33.3609Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.09313 17H5.54727'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M30.9069 17H28.4527'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M17 3.09363L17 5.54777'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M17 30.9064L17 28.4522'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M10.0468 29.045L11.2739 26.9197'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M23.9532 4.957L22.7261 7.08235'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M4.956 10.0478L7.08135 11.2749'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M29.0435 23.9542L26.9182 22.7271'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M23.9532 29.045L22.7261 26.9197'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M10.0468 4.957L11.2739 7.08235'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M4.956 23.9542L7.08135 22.7271'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M29.0435 10.0478L26.9182 11.2749'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M17 8.81955V17L21.9083 19.8632'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M17 33.3609C26.0359 33.3609 33.3609 26.0359 33.3609 17C33.3609 7.96412 26.0359 0.639098 17 0.639098C7.96412 0.639098 0.639098 7.96412 0.639098 17C0.639098 26.0359 7.96412 33.3609 17 33.3609Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.09313 17H5.54727'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M30.9069 17H28.4527'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M17 3.09363L17 5.54777'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M17 30.9064L17 28.4522'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M10.0468 29.043L11.2739 26.9177'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M23.9532 4.957L22.7261 7.08235'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M4.956 10.0458L7.08135 11.2729'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M29.0435 23.9542L26.9182 22.7271'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M23.9532 29.043L22.7261 26.9177'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M10.0468 4.957L11.2739 7.08235'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M4.956 23.9542L7.08135 22.7271'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M29.0435 10.0458L26.9182 11.2729'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M17 8.81955V17L21.9083 19.8632'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  'purchase-refills': {
    viewBox: '0 0 32 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M2.2666 16.8926H13.1999V27.1592C13.1999 30.1784 10.7524 32.6259 7.73327 32.6259V32.6259C4.71411 32.6259 2.2666 30.1784 2.2666 27.1592V16.8926Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M1.7334 6.625C1.7334 3.31129 4.41969 0.625 7.7334 0.625V0.625C11.0471 0.625 13.7334 3.31129 13.7334 6.625V16.266C13.7334 16.6116 13.4533 16.8917 13.1078 16.8917H2.35904C2.01351 16.8917 1.7334 16.6116 1.7334 16.266V6.625Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M19.0669 16.8926H30.0002V27.1592C30.0002 30.1784 27.5527 32.6259 24.5336 32.6259V32.6259C21.5144 32.6259 19.0669 30.1784 19.0669 27.1592V16.8926Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M18.5337 6.625C18.5337 3.31129 21.22 0.625 24.5337 0.625V0.625C27.8474 0.625 30.5337 3.31129 30.5337 6.625V16.266C30.5337 16.6116 30.2536 16.8917 29.9081 16.8917H19.1593C18.8138 16.8917 18.5337 16.6116 18.5337 16.266V6.625Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  scicare: {
    viewBox: '0 0 33 33',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M24.2384 11.8592C27.6298 11.8592 30.1215 9.36753 30.1215 6.73742C30.1215 4.10731 28.1836 1.33878 24.2384 1.33878H8.20318C3.87139 1.33878 0.627414 4.30994 0.627414 8.63532C0.627414 10.5428 1.02881 12.4452 2.36694 13.6495'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M24.0673 11.8687L11.1298 11.8687C6.80734 11.8687 3.30333 15.3485 3.30333 19.641C3.30333 23.9335 6.80734 27.4133 11.1298 27.4133H20.6849L23.3321 32.0964L26.0475 27.2705C29.6518 26.5753 32.3729 23.4237 32.3729 19.641C32.3729 17.1394 31.1829 14.9138 29.3342 13.4922'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <circle
          cx='10.2619'
          cy='19.8058'
          r='2.141'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <circle
          cx='17.7555'
          cy='19.8058'
          r='2.141'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <circle
          cx='25.2486'
          cy='19.8058'
          r='2.141'
          stroke='currentColor'
          strokeWidth='1.25'
        />
      </>
    ),
  },
  anniversary: {
    viewBox: '0 0 32 33',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M16.502 32.191C13.7424 29.8769 12.1074 25.1238 13.6787 19.8789'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M7.10459 29.547C6.23022 26.0526 7.76824 21.3177 12.1217 17.9968'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M1.05739 21.8827C2.40379 18.5439 6.78843 14.9125 12.0839 15.2122'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M0.666641 12.1292C3.72095 10.2183 8.71501 9.99391 13.2158 13.1088'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M6.08607 4.00839C9.67831 4.25874 14.4375 7.33581 15.5745 12.4725'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M15.2432 0.625C18.0028 2.93911 19.7073 7.89002 18.136 13.1349'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M24.6413 3.26898C25.5156 6.76339 24.047 11.6959 19.6935 15.0168'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M30.6878 10.9334C29.3414 14.2722 25.3891 17.3974 19.9156 17.5216'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M31.0788 20.6873C28.0254 22.5954 22.994 22.8018 18.4932 19.6869'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M25.6596 28.8079C22.0665 28.5604 17.7675 25.6483 16.3804 20.5859'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
      </>
    ),
  },
  'gut-immune-health': {
    viewBox: '0 0 32 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M15.9041 11.2917C18.8497 11.2917 21.2375 8.90385 21.2375 5.95833C21.2375 3.01281 18.8497 0.625 15.9041 0.625C12.9586 0.625 10.5708 3.01281 10.5708 5.95833C10.5708 8.90385 12.9586 11.2917 15.9041 11.2917Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.9041 32.6257C18.8497 32.6257 21.2375 30.2378 21.2375 27.2923C21.2375 24.3468 18.8497 21.959 15.9041 21.959C12.9586 21.959 10.5708 24.3468 10.5708 27.2923C10.5708 30.2378 12.9586 32.6257 15.9041 32.6257Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.66683 27.2917C9.61235 27.2917 12.0002 24.9039 12.0002 21.9583C12.0002 19.0128 9.61235 16.625 6.66683 16.625C3.72131 16.625 1.3335 19.0128 1.3335 21.9583C1.3335 24.9039 3.72131 27.2917 6.66683 27.2917Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M25.1444 16.6257C28.0899 16.6257 30.4777 14.2378 30.4777 11.2923C30.4777 8.3468 28.0899 5.95898 25.1444 5.95898C22.1988 5.95898 19.811 8.3468 19.811 11.2923C19.811 14.2378 22.1988 16.6257 25.1444 16.6257Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M25.1444 27.2917C28.0899 27.2917 30.4777 24.9039 30.4777 21.9583C30.4777 19.0128 28.0899 16.625 25.1444 16.625C22.1988 16.625 19.811 19.0128 19.811 21.9583C19.811 24.9039 22.1988 27.2917 25.1444 27.2917Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.66683 16.6257C9.61235 16.6257 12.0002 14.2378 12.0002 11.2923C12.0002 8.3468 9.61235 5.95898 6.66683 5.95898C3.72131 5.95898 1.3335 8.3468 1.3335 11.2923C1.3335 14.2378 3.72131 16.6257 6.66683 16.6257Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  'gut-barrier': {
    viewBox: '0 0 34 33',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M0.632184 14.8359C2.42051 13.0377 5.31743 13.0377 7.10575 14.8359C8.89407 16.6341 11.791 16.6341 13.5793 14.8359C15.3676 13.0377 18.2646 13.0377 20.0529 14.8359C21.8412 16.6341 24.7381 16.6341 26.5264 14.8359C28.3148 13.0377 31.2117 13.0377 33 14.8359'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M23.9642 9.71008L19.6485 5.39437L23.9642 1.07866'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.6481 5.39529H31.5163'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.66797 9.70995L13.9837 5.39424L9.66797 1.07853'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.984 5.39529L2.11584 5.39529'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M0.632184 20.2299H10.3425C12.1302 20.2299 13.5793 21.679 13.5793 23.4667V32.3678'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M33 20.2299H23.2897C21.502 20.2299 20.0529 21.679 20.0529 23.4667V32.3678'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
      </>
    ),
  },
  'micronutrient-synthesis': {
    viewBox: '0 0 34 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M27.6347 25.1801C27.6347 24.2765 28.3672 23.544 29.2708 23.544C30.1744 23.544 30.9069 24.2765 30.9069 25.1801C30.9069 26.0836 30.1744 26.8161 29.2708 26.8161C28.3672 26.8161 27.6347 26.0836 27.6347 25.1801Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M8.81975 19.4541C8.81975 18.5505 9.55225 17.818 10.4558 17.818C11.3594 17.818 12.0919 18.5505 12.0919 19.4541C12.0919 20.3577 11.3594 21.0902 10.4558 21.0902C9.55225 21.0902 8.81975 20.3577 8.81975 19.4541Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M15.364 31.7248C15.364 30.8212 16.0965 30.0887 17.0001 30.0887C17.9037 30.0887 18.6362 30.8212 18.6362 31.7248C18.6362 32.6284 17.9037 33.3609 17.0001 33.3609C16.0965 33.3609 15.364 32.6284 15.364 31.7248Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M21.0904 12.9094C21.0904 12.0058 21.8229 11.2733 22.7265 11.2733C23.6301 11.2733 24.3626 12.0058 24.3626 12.9094C24.3626 13.813 23.6301 14.5455 22.7265 14.5455C21.8229 14.5455 21.0904 13.813 21.0904 12.9094Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M13.7278 8.54753C13.7278 7.64395 14.4603 6.91144 15.3639 6.91144C16.2675 6.91144 17 7.64395 17 8.54753C17 9.45112 16.2675 10.1836 15.3639 10.1836C14.4603 10.1836 13.7278 9.45112 13.7278 8.54753Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M15.364 2.27439C15.364 1.3708 16.0965 0.638299 17.0001 0.638299C17.9037 0.638299 18.6362 1.3708 18.6362 2.27439C18.6362 3.17798 17.9037 3.91048 17.0001 3.91048C16.0965 3.91048 15.364 3.17798 15.364 2.27439Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M17.0002 25.1801C17.0002 24.2765 17.7327 23.544 18.6363 23.544C19.5399 23.544 20.2724 24.2765 20.2724 25.1801C20.2724 26.0836 19.5399 26.8161 18.6363 26.8161C17.7327 26.8161 17.0002 26.0836 17.0002 25.1801Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M3.09333 23.5444C3.09333 22.6408 3.82584 21.9083 4.72942 21.9083C5.63301 21.9083 6.36551 22.6408 6.36551 23.5444C6.36551 24.4479 5.63301 25.1805 4.72942 25.1805C3.82584 25.1805 3.09333 24.4479 3.09333 23.5444Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M27.6347 9.63799C27.6347 8.73441 28.3672 8.0019 29.2708 8.0019C30.1744 8.0019 30.9069 8.73441 30.9069 9.63799C30.9069 10.5416 30.1744 11.2741 29.2708 11.2741C28.3672 11.2741 27.6347 10.5416 27.6347 9.63799Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M30.0887 16.9996C30.0887 16.096 30.8212 15.3635 31.7248 15.3635C32.6284 15.3635 33.3609 16.096 33.3609 16.9996C33.3609 17.9032 32.6284 18.6357 31.7248 18.6357C30.8212 18.6357 30.0887 17.9032 30.0887 16.9996Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M0.639297 16.9996C0.639297 16.096 1.3718 15.3635 2.27539 15.3635C3.17898 15.3635 3.91148 16.096 3.91148 16.9996C3.91148 17.9032 3.17898 18.6357 2.27539 18.6357C1.3718 18.6357 0.639297 17.9032 0.639297 16.9996Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M22.7261 29.2703C22.7261 28.3667 23.4586 27.6342 24.3622 27.6342C25.2658 27.6342 25.9983 28.3667 25.9983 29.2703C25.9983 30.1739 25.2658 30.9064 24.3622 30.9064C23.4586 30.9064 22.7261 30.1739 22.7261 29.2703Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M6.91094 5.27415C6.91094 4.37057 7.64345 3.63806 8.54703 3.63806C9.45062 3.63806 10.1831 4.37057 10.1831 5.27415C10.1831 6.17774 9.45062 6.91024 8.54703 6.91024C7.64345 6.91024 6.91094 6.17774 6.91094 5.27415Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <rect
          x='12.9248'
          y='14.2219'
          width='3.27218'
          height='7.36241'
          rx='1.6'
          transform='rotate(-30 12.9248 14.2219)'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <rect
          x='26.3238'
          y='2.29077'
          width='3.27218'
          height='7.36241'
          rx='1.6'
          transform='rotate(60 26.3238 2.29077)'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <rect
          x='2.79505'
          y='12.756'
          width='3.27218'
          height='7.36241'
          rx='1.6'
          transform='rotate(-75 2.79505 12.756)'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <rect
          x='10.8796'
          y='24.0381'
          width='3.27218'
          height='7.36241'
          rx='1.6'
          transform='rotate(30 10.8796 24.0381)'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <rect
          x='24.6542'
          y='15.7697'
          width='3.27218'
          height='7.36241'
          rx='1.6'
          transform='rotate(30 24.6542 15.7697)'
          stroke='currentColor'
          strokeWidth='1.25'
        />
      </>
    ),
  },
  'feeds-the-microbiome': {
    viewBox: '0 0 34 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M32.5518 22.3622C31.4693 21.2798 29.716 21.2798 28.6336 22.3622L22.365 28.6302C22.2232 28.772 22.1033 28.9247 21.9996 29.0855C21.896 28.9247 21.7761 28.772 21.6343 28.6302L17.2444 24.2407C16.5027 23.4991 15.4475 23.2783 14.5068 23.5536C14.7822 22.613 14.5641 21.5579 13.8197 20.8163L8.98264 15.9824C7.90017 14.9 6.14419 14.9 5.06444 15.9824C3.98196 17.0648 3.98196 18.8178 5.06444 19.9002L9.64522 24.4806H3.40938C1.87973 24.4806 0.639098 25.7211 0.639098 27.2506C0.639098 28.7802 1.87973 30.0207 3.40938 30.0207H10.6677C11.8947 30.0207 12.9226 29.2191 13.288 28.1149C13.3016 28.1285 13.3098 28.1449 13.3235 28.1585L17.7134 32.5481C18.7958 33.6305 20.5491 33.6305 21.6315 32.5481C21.7733 32.4063 21.8933 32.2536 21.9969 32.0927C22.1005 32.2536 22.2205 32.4063 22.3623 32.5481C23.4448 33.6305 25.198 33.6305 26.2805 32.5481L32.549 26.28C33.6315 25.1977 33.6315 23.4446 32.549 22.3622H32.5518Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M24.8515 10.2579V3.40913C24.8515 1.87961 23.6109 0.639098 22.0812 0.639098C20.5516 0.639098 19.311 1.87961 19.311 3.40913V10.2361L14.8393 5.76475C13.7568 4.68237 12.0008 4.68237 10.9211 5.76475C9.83861 6.84714 9.83861 8.60023 10.9211 9.68261L16.1753 14.9364C16.7152 15.4762 17.4241 15.7489 18.1331 15.7489C18.5366 15.7489 18.9374 15.6507 19.311 15.4762V20.3702C19.311 21.8997 20.5516 23.1402 22.0812 23.1402C23.6109 23.1402 24.8515 21.8997 24.8515 20.3702V14.4102C24.8515 13.5787 24.478 12.8425 23.8999 12.3354C24.478 11.8283 24.8515 11.0922 24.8515 10.2606V10.2579Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  'sustained-relief': {
    viewBox: '0 0 34 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M3.0931 19.4537L6.91064 19.4537C8.26602 19.4537 9.36478 18.355 9.36478 16.9996C9.36478 15.6442 8.26603 14.5455 6.91064 14.5455L3.0931 14.5455C1.73772 14.5455 0.638964 15.6442 0.638964 16.9996C0.638964 18.355 1.73772 19.4537 3.0931 19.4537Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M19.4542 30.9069L19.4542 27.0894C19.4542 25.734 18.3555 24.6352 17.0001 24.6352C15.6447 24.6352 14.546 25.734 14.546 27.0894L14.546 30.9069C14.546 32.2623 15.6447 33.361 17.0001 33.361C18.3555 33.361 19.4542 32.2623 19.4542 30.9069Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M7.74892 27.5392L9.62626 24.5323C10.3839 23.3187 12.0213 22.8812 13.2833 23.555C14.5454 24.2288 14.9543 25.7588 14.1966 26.9724L12.3193 29.9793C11.5616 31.1929 9.92426 31.6305 8.66219 30.9566C7.40013 30.2828 6.99124 28.7528 7.74892 27.5392Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M3.70078 21.7042L6.77072 19.9318C8.00973 19.2164 9.59404 19.6409 10.3094 20.8799C11.0247 22.1189 10.6002 23.7033 9.3612 24.4186L6.29126 26.191C5.05225 26.9064 3.46794 26.4818 2.7526 25.2428C2.03726 24.0038 2.46178 22.4195 3.70078 21.7042Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M14.5458 3.0931L14.5458 6.91064C14.5458 8.26602 15.6445 9.36478 16.9999 9.36478C18.3553 9.36478 19.454 8.26603 19.454 6.91064L19.454 3.0931C19.454 1.73772 18.3553 0.638964 16.9999 0.638964C15.6445 0.638964 14.5458 1.73772 14.5458 3.0931Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M6.46178 7.74842L9.46871 9.62576C10.6823 10.3834 11.1198 12.0208 10.446 13.2828C9.77221 14.5449 8.24218 14.9538 7.0286 14.1961L4.02167 12.3188C2.8081 11.5611 2.37054 9.92376 3.04435 8.66169C3.71817 7.39963 5.2482 6.99074 6.46178 7.74842Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M12.2963 3.69978L14.0687 6.76972C14.7841 8.00873 14.3596 9.59304 13.1206 10.3084C11.8816 11.0237 10.2972 10.5992 9.58191 9.3602L7.80948 6.29026C7.09414 5.05125 7.51865 3.46694 8.75766 2.7516C9.99666 2.03626 11.581 2.46078 12.2963 3.69978Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M30.9069 19.4537L27.0894 19.4537C25.734 19.4537 24.6352 18.355 24.6352 16.9996C24.6352 15.6442 25.734 14.5455 27.0894 14.5455L30.9069 14.5455C32.2623 14.5455 33.361 15.6442 33.361 16.9996C33.361 18.355 32.2623 19.4537 30.9069 19.4537Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M27.5382 7.74842L24.5313 9.62576C23.3177 10.3834 22.8802 12.0208 23.554 13.2828C24.2278 14.5449 25.7578 14.9538 26.9714 14.1961L29.9783 12.3188C31.1919 11.5611 31.6295 9.92376 30.9556 8.66169C30.2818 7.39963 28.7518 6.99074 27.5382 7.74842Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M21.7037 3.69978L19.9313 6.76972C19.2159 8.00873 19.6404 9.59304 20.8794 10.3084C22.1184 11.0237 23.7028 10.5992 24.4181 9.3602L26.1905 6.29026C26.9059 5.05125 26.4813 3.46694 25.2423 2.7516C24.0033 2.03626 22.419 2.46078 21.7037 3.69978Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M26.2511 27.5392L24.3737 24.5323C23.6161 23.3187 21.9787 22.8812 20.7167 23.555C19.4546 24.2288 19.0457 25.7588 19.8034 26.9724L21.6807 29.9793C22.4384 31.1929 24.0757 31.6305 25.3378 30.9566C26.5999 30.2828 27.0088 28.7528 26.2511 27.5392Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M30.2992 21.7042L27.2293 19.9318C25.9903 19.2164 24.406 19.6409 23.6906 20.8799C22.9753 22.1189 23.3998 23.7033 24.6388 24.4186L27.7087 26.191C28.9477 26.9064 30.5321 26.4818 31.2474 25.2428C31.9627 24.0038 31.5382 22.4195 30.2992 21.7042Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
      </>
    ),
  },
  book: {
    viewBox: '0 0 26 21',
    fill: 'none',
    paths: () => (
      <>
        <path
          fill='currentColor'
          d='M4.10059 6.27284v1.5H1.75V18.5521h22.5V7.77284h-2.1172v-1.5H25.75V20.0521H.25V6.27284h3.85059Z'
        />
        <path
          fill='currentColor'
          d='M22.9068 14.5952V.750427L12.774 6.14789l-.3975.21094V20.2036l10.5303-5.6084Zm-9.0303-7.33501 7.5303-4.01074V13.6948l-7.5303 4.0107V7.26019Z'
        />
        <path
          fill='currentColor'
          d='M3.34625 14.5952V.750427L13.4791 6.14789l.3974.21094V20.2036L3.34625 14.5952Zm9.03025-7.33501L4.84625 3.24945V13.6948l7.53025 4.0107V7.26019Z'
        />
      </>
    ),
  },
  'caffeine-free': {
    viewBox: '0 0 32 32',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M16 30.6667C24.1002 30.6667 30.6667 24.1002 30.6667 16C30.6667 7.89986 24.1002 1.33337 16 1.33337C7.89983 1.33337 1.33334 7.89986 1.33334 16C1.33334 24.1002 7.89983 30.6667 16 30.6667Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.63074 26.3721L26.3718 5.62854'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  'deep-restful-sleep': {
    viewBox: '0 0 32 32',
    fill: 'none',
    paths: () => (
      <>
        <circle
          cx='16'
          cy='8.66671'
          r='7.33333'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <circle
          cx='16'
          cy='12.6154'
          r='11.2821'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <circle
          cx='16'
          cy='16'
          r='14.6667'
          stroke='currentColor'
          strokeWidth='1.25'
        />
      </>
    ),
  },
  'fall-asleep-fast': {
    viewBox: '0 0 32 32',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M5.51175 29.9835C5.51175 22.9915 12.5038 21.2435 12.5038 15.9994C12.5038 10.7554 5.51175 9.00741 5.51175 2.01538'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M26.4882 29.9835C26.4882 22.9915 19.4962 21.2435 19.4962 15.9994C19.4962 10.7554 26.4882 9.00741 26.4882 2.01538'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M22.992 29.9846C22.992 22.9925 16 21.2445 16 16.0005C16 21.2445 9.00797 22.9925 9.00797 29.9846H22.992Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M22.992 2.01538C22.992 9.00741 16 10.7554 16 15.9994C16 10.7554 9.00797 9.00741 9.00797 2.01538H22.992Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  'immune-defense': {
    viewBox: '0 0 33 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M16.2078 26.9722C21.9224 26.9722 26.555 22.3396 26.555 16.625C26.555 10.9104 21.9224 6.27783 16.2078 6.27783C10.4933 6.27783 5.86066 10.9104 5.86066 16.625C5.86066 22.3396 10.4933 26.9722 16.2078 26.9722Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.215 11.4451L2.38327 8.65555M7.215 21.8336L2.37418 24.6285M16.1934 32.625V27.0423M30.0002 24.6213L25.1718 21.8336M30.0467 8.63063L25.1718 11.4451M16.1934 6.23651V0.625M12.6827 0.625H19.6467M0.653853 11.6466L4.16465 5.57464M4.13589 27.6754L0.625092 21.6034M19.7042 32.625H12.7402M31.7618 21.5746L28.251 27.6466M28.2798 5.57464L31.7906 11.6466'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  'mental-clarity': {
    viewBox: '0 0 32 34',
    fill: 'none',
    paths: () => (
      <>
        <circle
          cx='15.9999'
          cy='11.6667'
          r='10.6667'
          stroke='currentColor'
          strokeWidth='1.52'
        />
        <circle
          cx='15.9999'
          cy='22.3334'
          r='10.6667'
          stroke='currentColor'
          strokeWidth='1.52'
        />
      </>
    ),
  },
  'nutrient-absorption': {
    viewBox: '0 0 34 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M16.8876 32.7935C17.1821 32.7935 17.4209 32.5547 17.4209 32.2601C17.4209 31.9656 17.1821 31.7268 16.8876 31.7268C16.593 31.7268 16.3542 31.9656 16.3542 32.2601C16.3542 32.5547 16.593 32.7935 16.8876 32.7935Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
        />
        <path
          d='M11.2999 28.9208C11.5945 28.9208 11.8333 28.682 11.8333 28.3875C11.8333 28.0929 11.5945 27.8541 11.2999 27.8541C11.0054 27.8541 10.7666 28.0929 10.7666 28.3875C10.7666 28.682 11.0054 28.9208 11.2999 28.9208Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
        />
        <path
          d='M22.4755 27.8541C22.7612 27.8541 23.0088 28.0827 23.0088 28.3875C23.0088 28.6922 22.7802 28.9208 22.4755 28.9208C22.1707 28.9208 21.9421 28.6922 21.9421 28.3875C21.9421 28.0827 22.1707 27.8541 22.4755 27.8541Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M16.8876 23.9333C17.1733 23.9333 17.4209 24.1619 17.4209 24.4667C17.4209 24.7714 17.1923 25 16.8876 25C16.5828 25 16.3542 24.7714 16.3542 24.4667C16.3542 24.1619 16.5828 23.9333 16.8876 23.9333Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <rect
          x='0.733398'
          y='13.2667'
          width='9.42222'
          height='7.46667'
          rx='2.13333'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <rect
          x='12.2888'
          y='13.2667'
          width='9.42222'
          height='7.46667'
          rx='2.13333'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <rect
          x='23.8445'
          y='13.2667'
          width='9.42222'
          height='7.46667'
          rx='2.13333'
          stroke='currentColor'
          strokeWidth='1.25'
        />
        <path
          d='M5.93201 10.0667C6.22657 10.0667 6.46534 9.82789 6.46534 9.53334C6.46534 9.23878 6.22657 9 5.93201 9C5.63746 9 5.39868 9.23878 5.39868 9.53334C5.39868 9.82789 5.63746 10.0667 5.93201 10.0667Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
        />
        <path
          d='M17.1542 10.0667C17.4487 10.0667 17.6875 9.82789 17.6875 9.53334C17.6875 9.23878 17.4487 9 17.1542 9C16.8596 9 16.6208 9.23878 16.6208 9.53334C16.6208 9.82789 16.8596 10.0667 17.1542 10.0667Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
        />
        <path
          d='M28.3539 10.0667C28.6484 10.0667 28.8872 9.82789 28.8872 9.53334C28.8872 9.23878 28.6484 9 28.3539 9C28.0593 9 27.8206 9.23878 27.8206 9.53334C27.8206 9.82789 28.0593 10.0667 28.3539 10.0667Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
        />
        <path
          d='M11.5668 6.28566C11.8613 6.28566 12.1001 6.04688 12.1001 5.75233C12.1001 5.45778 11.8613 5.21899 11.5668 5.21899C11.2722 5.21899 11.0334 5.45778 11.0334 5.75233C11.0334 6.04688 11.2722 6.28566 11.5668 6.28566Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
        />
        <path
          d='M22.7421 6.28566C23.0366 6.28566 23.2754 6.04688 23.2754 5.75233C23.2754 5.45778 23.0366 5.21899 22.7421 5.21899C22.4475 5.21899 22.2087 5.45778 22.2087 5.75233C22.2087 6.04688 22.4475 6.28566 22.7421 6.28566Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
        />
        <path
          d='M17.1542 2.52992C17.4487 2.52992 17.6875 2.29114 17.6875 1.99659C17.6875 1.70204 17.4487 1.46326 17.1542 1.46326C16.8596 1.46326 16.6208 1.70204 16.6208 1.99659C16.6208 2.29114 16.8596 2.52992 17.1542 2.52992Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeMiterlimit='10'
        />
      </>
    ),
  },
  'refreshed-mornings': {
    viewBox: '0 0 34 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M31.107 8.78451L28.5964 10.2035M2.80815 25.158L5.31875 23.739M8.75717 2.80817L10.1762 5.31877M25.1307 31.1344L23.7117 28.6238M31.107 25.158L28.5964 23.739M2.80815 8.78451L5.31875 10.2035M25.1307 2.80817L23.7117 5.31877M8.75717 31.1344L10.1762 28.6238M16.9439 33.3175V30.4249M16.9439 0.62502V3.51769M33.2902 16.9713H30.3975M0.625 16.9713H3.51765'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
        />
        <path
          d='M16.9576 6.30457C22.8553 6.30457 27.6242 11.0735 27.6242 16.9712C27.6242 22.8689 22.8553 27.6379 16.9576 27.6379C11.0599 27.6379 6.29092 22.8689 6.29092 16.9712C6.29092 11.0735 11.0599 6.30457 16.9576 6.30457Z'
          stroke='currentColor'
          strokeWidth='1.25'
        />
      </>
    ),
  },
  'restorative-sleep': {
    viewBox: '0 0 34 32',
    fill: 'none',
    paths: () => (
      <path
        d='M32.625 9.85369C30.1469 9.85369 30.7287 21.2683 27.6688 21.2683C24.6089 21.2683 25.7725 9.85369 22.8634 9.85369C19.6095 9.85369 21.0102 26.6992 17.7563 26.6667C14.524 26.6667 16.0109 9.85369 12.7785 9.85369C9.50312 9.85369 11.1624 26.6667 7.28358 26.6667C3.21085 26.6667 5.51659 5.33337 0.625 5.33337'
        stroke='currentColor'
        strokeWidth='1.25'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
    ),
  },
  'sharper-focus': {
    viewBox: '0 0 34 32',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M15.9284 15.5966C15.7084 15.9633 15.855 16.4766 16.2217 16.6966C16.5883 16.9166 17.1017 16.7699 17.3217 16.4033C17.5416 16.0366 17.395 15.5233 17.0283 15.3033C16.6617 15.0833 16.1484 15.23 15.9284 15.5966Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M16.625 26.6666L0.624998 16L16.625 5.33329L32.625 16L16.625 26.6666Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  'sustained-energy': {
    viewBox: '0 0 34 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M19.0463 15.6103H24.4863L10.6804 33.2675L14.5337 18.2822H9.09372L22.879 0.625L19.0463 15.6103Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinejoin='round'
        />
        <path
          d='M19.1491 15.6113H33.2435'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.957 18.2816H0.625'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  'skin-health': {
    viewBox: '0 0 33.25 33.25',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M0.625 15.5584C0.625 15.5584 8.60633 15.5584 10.225 15.5584C11.6783 15.5584 12.3583 16.6251 12.3583 17.6918C12.3583 19.8251 9.15833 21.9584 9.15833 26.2251C9.15833 29.9771 12.3583 32.6251 16.625 32.6251C20.8917 32.6251 24.0917 29.9771 24.0917 26.2251C24.0917 21.9584 20.8917 19.8251 20.8917 17.6918C20.8917 16.6251 21.5717 15.5584 23.025 15.5584C24.6437 15.5584 32.625 15.5584 32.625 15.5584'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.6143 18.7584C16.6143 5.95842 25.1583 0.625084 25.1583 0.625084'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.8917 28.2864C14.1104 27.8784 13.0197 25.9557 13.5557 24.2091C13.9957 22.7744 15.3131 21.7077 16.6144 18.6037C18.2064 22.4064 19.8251 23.1531 19.8251 25.2597C19.8251 27.2197 17.8944 28.7451 15.8891 28.2864H15.8917Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
  'whole-body-support': {
    viewBox: '0 0 33 34',
    fill: 'none',
    paths: () => (
      <>
        <path
          d='M19.2951 26.7319C20.9124 26.7319 22.2276 28.0471 22.2276 29.6644C22.2276 31.2817 20.9124 32.5969 19.2951 32.5969H13.4124C11.795 32.5969 10.4799 31.2817 10.4799 29.6644C10.4799 28.0471 11.795 26.7319 13.4124 26.7319H19.2951Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.4297 6.48995C11.8124 6.48995 10.4973 5.17478 10.4973 3.55748C10.4973 1.94017 11.8124 0.625 13.4297 0.625H19.3125C20.9298 0.625 22.2449 1.94017 22.2449 3.55748C22.2449 5.17478 20.9298 6.48995 19.3125 6.48995H13.4297Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M23.6488 9.01266C22.8312 7.60862 23.3111 5.81359 24.7329 4.99605C26.1547 4.17852 27.932 4.65838 28.7495 6.08018L31.682 11.1631C32.4995 12.5672 32.0196 14.3622 30.5978 15.1797C29.176 15.9973 27.3988 15.5174 26.5813 14.0956L23.6488 9.01266Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.05666 24.2079C9.8742 25.612 9.39434 27.407 7.97254 28.2245C6.55073 29.0421 4.77349 28.5622 3.95595 27.1404L1.02346 22.0574C0.205922 20.6534 0.685782 18.8584 2.10759 18.0409C3.52939 17.2233 5.30664 17.7032 6.12418 19.125L9.05666 24.2079Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.12627 14.0961C5.30873 15.5001 3.51371 15.9799 2.10968 15.1802C0.705645 14.3804 0.225785 12.5676 1.02555 11.1636L3.95804 6.08062C4.77558 4.67659 6.5706 4.19673 7.97463 4.9965C9.37866 5.79626 9.85852 7.60907 9.05876 9.0131L6.12627 14.0961Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M26.6007 19.1253C27.4182 17.7213 29.2133 17.2414 30.6173 18.0412C32.0214 18.8409 32.5012 20.6537 31.7014 22.0578L28.769 27.1407C27.9514 28.5447 26.1564 29.0246 24.7524 28.2248C23.3483 27.4251 22.8685 25.6123 23.6683 24.2083L26.6007 19.1253Z'
          stroke='currentColor'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ),
  },
} satisfies Record<string, BrandIconDef>;

export type BrandIconName = keyof typeof brandIcons;
